import {debugLog} from "../Utils/LogUtils";
import { useEffect } from 'react';
import {
    calculateLifetimeDepositAmount,
    calculateMonthlyDepositAmount,
    calculateYearlyDepositAmount, stateWithPlan2AsPrimary
} from '../Utils/PlanUtils';

//When the quote is based on units, we need to update the deposit amount based on the number of units and other factors
const useUpdateDepositBasedOnUnits = (state) => {
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (state.quote.quoteBasedOn === 'units') {
            let calculateFunction = calculateMonthlyDepositAmount;
            if (state.quote.depositFrequency === 'A') {
                calculateFunction = calculateYearlyDepositAmount;
            } else if (state.quote.depositFrequency === 'T') {
                calculateFunction = calculateLifetimeDepositAmount;
            }
            state.setPlan(prevData => ({
                ...prevData,
                depositAmount: calculateFunction(state, true)
            }));
        }
        debugLog("useUpdateDepositBasedOnUnits");
    }, [
        state.quote.quoteBasedOn,
        state.quote.depositFrequency,
        state.plan.numberOfUnits,
        state.plan.depositMode,
        state.plan.depositCode,
        state.plan.completionInsurance,
        state.plan.nomineeInsurance,
        state.plan.criticalIllnessInsurance
    ]);



    useEffect(() => {
        if (!state.enrollment.state) { return; }
        if (state.quote2.quoteBasedOn === 'units') {
            let calculateFunction = calculateMonthlyDepositAmount;
            if (state.quote2.depositFrequency === 'A') {
                calculateFunction = calculateYearlyDepositAmount;
            } else if (state.quote2.depositFrequency === 'T') {
                calculateFunction = calculateLifetimeDepositAmount;
            }
            state.setPlan2(prevData => ({
                ...prevData,
                depositAmount: calculateFunction(stateWithPlan2AsPrimary(state), true)
            }));
        }
        debugLog("useUpdateDepositBasedOnUnits");
    }, [
        state.quote2.quoteBasedOn,
        state.quote2.depositFrequency,
        state.plan2.numberOfUnits,
        state.plan2.depositMode,
        state.plan2.depositCode,
        state.plan2.completionInsurance,
        state.plan2.nomineeInsurance,
        state.plan2.criticalIllnessInsurance
    ]);
}

export default useUpdateDepositBasedOnUnits;